import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import "./Class.css";

const Class = () => {
  const navigate = useNavigate();

  const onLogo1ContainerClick = useCallback(() => {
    navigate("/");
  }, [navigate]);

  const onHomeContainerClick = useCallback(() => {
    navigate("/");
  }, [navigate]);

  const onAboutContainerClick = useCallback(() => {
    navigate("/aboutus");
  }, [navigate]);

  const onOurProductsTextClick = useCallback(() => {
    navigate("/our-products");
  }, [navigate]);

  const onButtonDesktopSecondaryClick = useCallback(() => {
    navigate("/login");
  }, [navigate]);

  const onButtonDesktopPrimaryClick = useCallback(() => {
    navigate("/step1");
  }, [navigate]);

  return (
    <div className="class-div">
      <div className="nav-div1">
        <div className="logo1-div9" onClick={onLogo1ContainerClick}>
          <img className="vector-icon240" alt="" src="../vector.svg" />
          <img className="vector-icon241" alt="" src="../vector1.svg" />
          <img className="vector-icon242" alt="" src="../vector2.svg" />
          <img className="vector-icon243" alt="" src="../vector3.svg" />
          <img className="vector-icon244" alt="" src="../vector244.svg" />
          <img className="vector-icon245" alt="" src="../vector245.svg" />
          <img className="vector-icon246" alt="" src="../vector6.svg" />
          <img className="vector-icon247" alt="" src="../vector247.svg" />
          <img className="vector-icon248" alt="" src="../vector8.svg" />
          <img className="vector-icon249" alt="" src="../vector9.svg" />
          <img className="vector-icon250" alt="" src="../vector10.svg" />
          <img className="vector-icon251" alt="" src="../vector11.svg" />
          <img className="vector-icon252" alt="" src="../vector252.svg" />
          <img className="vector-icon253" alt="" src="../vector253.svg" />
          <img className="vector-icon254" alt="" src="../vector14.svg" />
          <img className="vector-icon255" alt="" src="../vector15.svg" />
          <img className="vector-icon256" alt="" src="../vector16.svg" />
          <img className="vector-icon257" alt="" src="../vector17.svg" />
          <img className="vector-icon258" alt="" src="../vector18.svg" />
          <img className="vector-icon259" alt="" src="../vector259.svg" />
          <img className="vector-icon260" alt="" src="../vector260.svg" />
          <img className="vector-icon261" alt="" src="../vector261.svg" />
          <img className="vector-icon262" alt="" src="../vector22.svg" />
          <img className="vector-icon263" alt="" src="../vector23.svg" />
          <img className="vector-icon264" alt="" src="../vector264.svg" />
          <b className="shuleeazy-b11">ShuleEazy</b>
        </div>
        <div className="frame-div92">
          <div className="frame-div93">
            <div className="home-div" onClick={onHomeContainerClick}>
              <b className="home-b1">Home</b>
            </div>
            <div className="home-div" onClick={onAboutContainerClick}>
              <b className="home-b1">About Us</b>
            </div>
            <div className="products-div1">
              <div className="frame-div94">
                <b className="our-products-b1" onClick={onOurProductsTextClick}>
                  Our Products
                </b>
                <img
                  className="fluenthat-graduation-24-regul-icon"
                  alt=""
                  src="../outline-24px--chevrondown1.svg"
                />
              </div>
            </div>
            <div className="contact-div1">
              <b className="home-b1">Contact Us</b>
            </div>
          </div>
          <div className="frame-div95">
            <button
              className="buttondesktopsecondary3"
              onClick={onButtonDesktopSecondaryClick}
            >
              <b className="save-and-next20">log in</b>
            </button>
            <button
              className="buttondesktopprimary12"
              onClick={onButtonDesktopPrimaryClick}
            >
              <b className="save-and-next21">sign up</b>
            </button>
          </div>
        </div>
      </div>
      <div className="content-div">
        <div className="frame-div96">
          <b className="mathematics-b">Mathematics</b>
          <b className="this-lesson-is-to-help-learner">
            This lesson is to help learners understand basic maths concepts such
            as addition, subtraction, multiplication and diviision
          </b>
          <div className="rating-stars-div">
            <img className="star-icon" alt="" src="../star-1.svg" />
            <img className="star-icon" alt="" src="../star-1.svg" />
            <img className="star-icon" alt="" src="../star-1.svg" />
            <img className="star-icon" alt="" src="../star-1.svg" />
            <img className="star-icon" alt="" src="../star-1.svg" />
          </div>
          <div className="frame-div97">
            <div className="classes-div">
              <img
                className="fluenthat-graduation-24-regul-icon"
                alt=""
                src="../fluenthatgraduation24regular.svg"
              />
              <div className="ksh-5000-div">2 Classes</div>
            </div>
            <div className="classes-div">
              <img
                className="fluenthat-graduation-24-regul-icon"
                alt=""
                src="../akariconsbook.svg"
              />
              <div className="ksh-5000-div">14 Lessons</div>
            </div>
            <div className="classes-div">
              <img
                className="fluenthat-graduation-24-regul-icon"
                alt=""
                src="../biperson.svg"
              />
              <div className="ksh-5000-div">12 Learners</div>
            </div>
          </div>
        </div>
        <div className="frame-div98">
          <img
            className="unsplash9wnpgjauk94-icon"
            alt=""
            src="../unsplash9wnpgjauk94@2x.png"
          />
          <div className="frame-div99">
            <div className="price-div">
              <img
                className="akar-iconsmoney"
                alt=""
                src="../akariconsmoney.svg"
              />
              <div className="ksh-5000-div">Ksh 5,000</div>
            </div>
            <button className="buttondesktopprimary13">
              <b className="save-and-next22">ENROLL NOW</b>
            </button>
          </div>
        </div>
      </div>
      <div className="frame-div100">
        <div className="frame-div101">
          <b className="what-youll-learn">What You’ll Learn</b>
        </div>
        <div className="frame-div102">
          <b className="requirements-and-materials">
            Requirements and Materials
          </b>
          <div className="frame-div103">
            <div className="frame-div94">
              <img className="charmtick-icon" alt="" src="../charmtick.svg" />
              <div className="laptop-or-pc">Laptop or PC</div>
            </div>
            <div className="frame-div94">
              <img className="charmtick-icon" alt="" src="../charmtick.svg" />
              <div className="laptop-or-pc">Microsoft teams installed</div>
            </div>
            <div className="frame-div94">
              <img className="charmtick-icon" alt="" src="../charmtick.svg" />
              <div className="laptop-or-pc">Stable internet connection</div>
            </div>
            <div className="frame-div94">
              <img className="charmtick-icon" alt="" src="../charmtick.svg" />
              <div className="laptop-or-pc">Calm environment</div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-div1">
        <div className="frame-div108">
          <img
            className="fluenthat-graduation-24-regul-icon"
            alt=""
            src="../antdesigncopyrightoutlined1.svg"
          />
          <b className="requirements-and-materials">
            2022 ShuleEazy, All Rights Reserved
          </b>
        </div>
      </div>
    </div>
  );
};

export default Class;
